import React from "react";
import Banner from "../../banner/Banner";
import Navbar from "../../navbar/Navbar";
import Profilecard from "../../profilecard/Profilecard";
import Sidebarcomponent from "../../sidedraw/Sidebar.component";
import { connect } from "react-redux";
import { setMasterData, userProfileLoaded } from "../../services/actions/actions";
import { getUsersEntireData } from "../../functions/apis";
import Loading from "../../Loading/Loading";
import { useQuery } from 'react-query'
import ServerError from "../error/500/ServerError";
function Users({ setData, mainView,isInstitute,userProfileLoadeds }) {
  const { isError, isLoading, isSuccess, error } = useQuery('getUserData', getUsersEntireData, { onSuccess: data => { setData(data);userProfileLoadeds(false) } })
  if (isLoading) return <><div className="flex items-center justify-center w-full h-screen"><Loading className={'w-48'} /></div></>;
  if (isError) return <><div><ServerError message={error.response.status} error={error} /></div></>
  if (isSuccess) return <>
    <div className='hidden lg:block'>
      {
        <>
          <Navbar responsive="hidden lg:flex" />
          <Banner responsive="hidden lg:block" account />
          <div className="main-content-wrapper max-content-width hidden lg:flex ">
            <Sidebarcomponent isInstitute={isInstitute} />
            <Profilecard account />
            <div className="information_wrapper">
              {mainView}
            </div>
          </div>
        </>}
    </div>
  </>
}
const mapStateToProps = (state) => { return state };
const mapDispatchToState = (dispatch) => {
  return {
    setData: (value) => {
      dispatch(setMasterData(value));
    },
    userProfileLoadeds: (value) => {
      dispatch(userProfileLoaded(value));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToState)(Users);